import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CustomerReview = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Review data
  const reviews = [
  {
    title: "Authentic Flavors of Wayanad!",
    content:
      "The spices from Vantharaare unmatched in freshness and aroma. It feels like bringing the true essence of Wayanad right into my kitchen. Absolutely loved the experience!",
    author: "Aarav Menon",
    rating: 5,
  },
  {
    title: "Beautifully Crafted Products!",
    content:
      "Each product tells a story — you can feel the craftsmanship and care in every detail. Vantharaperfectly blends traditional artistry with modern design.",
    author: "Meera Krishnan",
    rating: 5,
  },
  {
    title: "Exceptional Quality & Service!",
    content:
      "The team at Vanthara is so passionate and helpful. My order arrived beautifully packed, and the quality exceeded expectations. A truly heartwarming brand!",
    author: "Rahul Iyer",
    rating: 5,
  },
  {
    title: "Nature-Inspired Perfection!",
    content:
      "I love how Vanthara products capture the beauty of nature. From their natural oils to handcrafted items, everything feels pure, soulful, and elegant.",
    author: "Ananya Nair",
    rating: 4,
  },
  {
    title: "Supporting Local Artisans!",
    content:
      "Knowing my purchase supports Wayanad’s artisans makes every product even more special. Vanthara is preserving tradition beautifully while creating something timeless.",
    author: "David Thomas",
    rating: 5,
  },
  {
    title: "Fast Delivery & Eco Packaging!",
    content:
      "My package arrived quickly and was packed sustainably. The attention to detail and eco-conscious approach truly reflect Vanathara’s values.",
    author: "Sneha Varma",
    rating: 5,
  },
];


  const itemsPerPage = 3;
  const totalPages = Math.ceil(reviews.length / itemsPerPage);

  // Handle page change
  const handleSlideChange = (index) => {
    setActiveIndex(index);
  };

  // Render star rating
  const renderStars = (rating) => (
    <div>
      {[...Array(5)].map((_, i) => (
        <span
          key={i}
          className={`me-1 ${i < rating ? "text-danger" : "text-secondary"}`}
          style={{ fontSize: "18px" }}
        >
          ★
        </span>
      ))}
    </div>
  );

  // Current slice of reviews
  const currentReviews = reviews.slice(
    activeIndex * itemsPerPage,
    activeIndex * itemsPerPage + itemsPerPage
  );

  return (
    <div className="bg-white py-5">
      <div className="container">
        {/* Title */}
        <div className="text-center mb-5">
          <h2 className="fw-bold display-6">Customer Review</h2>
        </div>

        {/* Reviews (3 at a time) */}
        <div className="row g-4 justify-content-center">
          {currentReviews.map((review, index) => (
            <div key={index} className="col-md-4">
              <div className="card h-100 border rounded shadow-sm p-3">
                <div className="card-body">
                  {/* Quote Icon */}
                  <div className="mb-3">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#7c0046",
                      }}
                    >
                      <span className="text-white fs-5">❝</span>
                    </div>
                  </div>

                  {/* Review Content */}
                  <h5 className="fw-bold mb-2">{review.title}</h5>
                  <p className="text-muted">{review.content}</p>

                  {/* Author & Rating */}
                  <div>
                    <h6 className="fw-bold text-dark mb-1">{review.author}</h6>
                    {renderStars(review.rating)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Dots */}
        <div className="text-center mt-4">
          {Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index}
              onClick={() => handleSlideChange(index)}
              className={`mx-2 rounded-circle border-0 ${
                index === activeIndex ? "bg-dark" : "bg-secondary"
              }`}
              style={{ width: "12px", height: "12px" }}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerReview;
